import { createModule } from 'reacticoon/module'

import discordAuthReducer from './reducer'

const DiscordAuthModule = createModule('DiscordAuthModule', {
  reducer: discordAuthReducer,
})

export default DiscordAuthModule
